import { ValidationFunctionResult } from '../../../../types/validation-function-result';
import { CreateVehicleMakeDto } from '../../dtos/create-vehicle-make.dto';
import { UpdateVehicleMakeDto } from '../../dtos/update-vehicle-make.dto';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleMakeDto | UpdateVehicleMakeDto,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!record) throw new Error('record is required.');

	// // Validate
	// const { error } = update....Schema().validate(record, {
	// 	abortEarly,
	// });

	// // Check
	// if (error) {
	// 	return {
	// 		isValid: false,
	// 		errors: error.details?.map((e) => e.message),
	// 	};
	// }

	// Return
	return { isValid: true };
};
